import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ModelBase } from 'store/model-base';
import { StoreAction } from 'store/actions';
import { UsageDetail, UsageSummary } from './models';
import { ApiChannel } from 'core/constants';
import { buildHeaders, Util, XmStore } from 'core/services';

@Injectable()
export class UsageApi {
    public static getUsageSummary(_xmStore: XmStore, http: HttpClient, params: ApiParams): Observable<UsageSummary> {
        return http.get(`/lines/${params.lineId}/usage`, {
            headers: buildHeaders({ apiChannel: ApiChannel.GATEWAY }),
            params: { startDate: UsageApi.getStartDate() }
        }).pipe(
            map((response: ApiResponse) => UsageSummary.create<UsageSummary>(response))
        );
    }

    public static getUsageDetail(_xmStore: XmStore, http: HttpClient, params: ApiParams): Observable<UsageDetail> {
        return http.get(`/account/statements/${params.statementLineId}/usage`, {
            headers: buildHeaders({
                apiChannel: ApiChannel.GATEWAY,
                'X-CycleEnd': params.cycleEndDate,
                'X-CycleStart': params.cycleStartDate
            })
        }).pipe(
            map((response: ApiResponse) => UsageDetail.create<UsageDetail>(response))
        );
    }

    private static getStartDate(): string {
        // YYYY-MM-DD format
        const threeMonthPrior: Date = Util.addMonths(new Date(), -3);

        return Util.dateFormat(threeMonthPrior.toString(), 'yyyy-MM-dd');
    }

}

ModelBase.fetchMapping[StoreAction.GET_USAGE_SUMMARY] = UsageApi.getUsageSummary;
ModelBase.fetchMapping[StoreAction.GET_USAGE_DETAIL] = UsageApi.getUsageDetail;
